import React from 'react';
import './NewsComponent.css';

const NewsComponent = ({ title, image, url }) => {
  const handleClick = () => {
    window.open(url, '_blank');
  };
  const truncateString = (title) => {
    return title.length > 60 ? `${title.substr(0, 56)}...` : title;
  };

  return (
    <div className="news-component" onClick={handleClick}>
      <h2 className="heavy overlap news-title">{truncateString(title)}</h2>
      <img className="news-img" src={image} alt={title}></img>
    </div>
  );
};

export default NewsComponent;
